import React from "react";
import { useUser } from "./UserProvider";
import { Chatbot } from "../../services/Chatbot";

/** チャットボットモデル */
type ChatbotModel = {
    /** サポートされているかを判定する値 */
    supported: boolean;
    /** 画像解析がサポートされているかを判定する値 */
    supportedAnalyze: boolean;

    /** 貼り付けURL */
    sourceUrl: string;
};

/** デフォルトモデル */
const DefaultModel: ChatbotModel = { supported: true, supportedAnalyze: false, sourceUrl: "" };

/** チャットボットコンテキスト */
const ChatbotContext = React.createContext<ChatbotModel>(DefaultModel);

/** AIチャットボットプロバイダー */
const ChatbotProvider = (props: { children: React.ReactNode }) => {
    const { children } = props;
    const [model, setModel] = React.useState<ChatbotModel>(DefaultModel);

    const { user, getAccessToken } = useUser();

    React.useEffect(() => {
        const controller = new AbortController();
        getAccessToken(controller.signal)
        .then(async (accessToken) => Chatbot.getSetting(accessToken!, user?.office!, controller.signal))
        .then(data => setModel({supported: true, supportedAnalyze: data.supported, sourceUrl: data.url}))
        .catch(error => {
            if (error.name !== "AbortError") {
                console.error(error);
            }
        });
        return () => controller.abort();
    }, [user, getAccessToken]);

    return (
        <ChatbotContext.Provider value={model}>{children}</ChatbotContext.Provider>
    );
};
export default ChatbotProvider;

/** AIチャットボットフック */
export const useChatbot = () => React.useContext(ChatbotContext);